import TabViewModel from "../../../../Lib/Fs.SmartClient.Client/TabViewModel";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import ResetPasswordTokenRequest from "../../Scripts/AppServiceContract/ResetPasswordTokenRequest";
import ChangePasswordUpdateRequest from "../../Scripts/AppServiceContract/ChangePasswordUpdateRequest";
import ResetPasswordUpdateRequest from "../../Scripts/AppServiceContract/ResetPasswordUpdateRequest";
import { useView, autoinject, Container } from 'aurelia-framework'
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";
import ChangePasswordAppService from "../../Scripts/AppServiceContract/ChangePasswordAppService";
import { User } from "oidc-client";
import { fs } from "../../../../Config/FsConfig";
import ActivateTokenRequest from "../../Scripts/AppServiceContract/ActivateTokenRequest";
import CreatePasswordData from "../../Scripts/AppServiceContract/CreatePasswordData";
import ActivateUserAppService from "../../Scripts/AppServiceContract/ActivateUserAppService";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./CreatePasswordView.html"))
export default class ChangePasswordVM extends TabViewModel {

    public OpenIdConnect: OpenIdConnect;
    constructor(openIdConnect: OpenIdConnect) {
        super();
        this.OpenIdConnect = openIdConnect;
    }

    public IsFromLogin: boolean = false;
    public ResourceId: string;
    public TokenKey: string;

    public NewPassword: string;
    public ConfirmPassword: string;

    public User: User;

    activate(params, route) {

        var self = this;

        this.ResourceId = params.ResourceId;
        this.TokenKey = params.TokenNo;

        var request = new ActivateTokenRequest();
        request.ResourceUID = this.ResourceId;
        request.TokenKey = this.TokenKey;
        request.IsChangePassword = true;

        var service = this.container.get(ChangePasswordAppService) as ChangePasswordAppService;
        service.CheckToken(request).done(function (result) {
            if (!result) {
                window.history.back();
            }
        }).fail(function (error) {
            FsUtility.AlertErrorMessage(error);
            window.history.back();
        });
    }

    Submit() {
        var self = this;
        if (this.NewPassword != this.ConfirmPassword) {
            FsUtility.AlertModal("Password and confirm password does not match", 1, 2);
            return;
        }
        var service = this.container.get(ActivateUserAppService) as ActivateUserAppService;
        var request = new CreatePasswordData();

        request.Password = this.NewPassword;
        request.TokenKey = this.TokenKey;
        request.UserId = this.ResourceId;
        service.CreatePassword(request)
            .done(function () {
                self.PageRedirect();
            }).fail((error) => {
                FsUtility.AlertErrorMessage(error);
            });
    }

    Cancel() {
        this.PageRedirect();
    }

  PageRedirect() {
    window.location.href = fs.Config.ClientBaseUrl + "Modules/Core/CreatePasswordPage#RedirectSuccess";
    }
}
